export const CLIENT_ID = 'efef34354d854ff6b2d5c34d2bf0dbfe';
export const CLIENT_PUBLIC = 'b4eea20e47e84a90b450cc0d8973a69b';
